import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FormMode } from '../utils/extensions/constantEx'
import { EmployeeFormContextProvider } from '../utils/contexts/employeeFormContext';
import EmployeeForm from './employeeForm';

export default function EmployeeFormWrapper(props) {

    const { formMode } = props;
    const location = useLocation();

    const [selectedEmployeeId, setSelectedEmployeeId] = useState(0);
    const [formOpenMode, setFormOpenMode] = useState(formMode ?? FormMode.NewMode);


    useEffect(() => {

        if (location && location.state && location.state.selectedId && location.state.selectedId > 0) {
            setFormOpenMode(FormMode.ViewMode);
            setSelectedEmployeeId(location.state.selectedId);
        } else {
            setFormOpenMode(formMode ?? FormMode.NewMode);
            setSelectedEmployeeId(0);
        }
    }, [location]);


    return (
        <EmployeeFormContextProvider>
            <EmployeeForm formMode={formOpenMode} selectedEmployeeId={selectedEmployeeId} />
        </EmployeeFormContextProvider>
    );

}
